<action class="wishlist-toggle cursor-pointer"
        [status]="status"
        [class.logged-in]="app.customer.model.isLoggedIn"
        (click)="toggle()"
        cy-wishlistAddBtn>
    <i class="wishlist-icon"
       [ngClass]="{
           'icon-wishlist-fill': inWishlist,
           'icon-wishlist': !inWishlist,
           'animating': animationState === 'animating'
       }"
       [style.font-size.em]="1.1"
       aria-hidden="true"></i>

    <div class="hearts-container"
         [ngClass]="{ 'show': animationState === 'animating' }">
        <div class="heart heart-left-1"></div>
        <div class="heart heart-left-2"></div>
        <div class="heart heart-right-1"></div>
        <div class="heart heart-right-2"></div>
    </div>
</action>
